import ResponsiveDialog from '~/src/components/mui-wrappers/responsive-dialog'
import { Typography, useMediaQuery } from '@mui/material'
import LoginTypeSelectionForm from '~/src/components/auth/login-type-selection/LoginTypeSelectionForm'
import { CustomMuiTheme, useCustomMuiTheme } from '~/src/hooks/useCustomMuiTheme'
import { useTranslations } from '~/src/hooks/useTranslations'
import { AuthenticationFlowDialogNameEnum } from '~/src/types/DialogNameEnum'
import AuthenticationDialogTitle from '~/src/components/auth/dialogs/AuthenticationDialogTitle'

const LoginTypeSelectionDialog = () => {
  const theme = useCustomMuiTheme()
  const { t } = useTranslations()
  const isSmallDevice = useMediaQuery((theme: CustomMuiTheme) => theme.breakpoints.down('md'))

  return (
    <ResponsiveDialog
      openByDefault={true}
      name={AuthenticationFlowDialogNameEnum.AUTHENTICATION_FLOW_LOGIN_TYPE_SELECTION}
      showPuller={isSmallDevice}
      fullWidth
      maxWidth='sm'
      showCloseButton
      Title={
        <AuthenticationDialogTitle>
          { t('auth.loginTypeSelection.dialog.title') }
        </AuthenticationDialogTitle>}
      titleSx={{
        px: `${theme.spacing(2)} !important`,
        gap: 1
      }}
      contentSx={{
        px: 3
      }}>
      <Typography
        variant='h6'
        sx={{
          fontSize: 'min(max(1rem, 4vw), 1.25rem)'
        }}>
        { t('auth.loginTypeSelection.dialog.subTitle') }
      </Typography>

      <LoginTypeSelectionForm fieldsColor='container'/>
    </ResponsiveDialog>
  )
}

export default LoginTypeSelectionDialog
